<template>
    <v-container>
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <v-card>
            <v-container>
                <v-layout>
                    <h3 style="font-size: 2em;">{{ TranslateText("System Settings")}}</h3>
                </v-layout>
                <br>
                <v-form ref="form" v-model="valid" @keyup.enter="SubmitForm">
                    <v-layout row wrap mt-3>
                        <v-flex xs6>
                            <v-text-field :rules="textRules" :label="TranslateText('RNG IP Address')" v-model="form.Rng_Ip"></v-text-field>
                            <v-text-field :rules="textRules" type="number" :label="TranslateText('RNG Port')" v-model="form.Rng_Port"></v-text-field>
                            <v-text-field :rules="textRules" :label="TranslateText('Clickatell Key')" v-model="form.Clickatell_Key"></v-text-field>
                            <v-text-field :rules="textRules" :label="TranslateText('Sendgrid Key')" v-model="form.Sendgrid_Key"></v-text-field>
                            <v-text-field :rules="textRules" :label="TranslateText('TCP In IP Address')" v-model="form.Tcp_In_Ip"></v-text-field>
                            <v-text-field :rules="textRules" type="number" :label="TranslateText('TCP In IP Port')"
                                v-model="form.Tcp_In_Port"></v-text-field>
                            <v-text-field :rules="textRules" :label="TranslateText('TCP Out IP Address')" v-model="form.Tcp_Out_Ip"></v-text-field>
                            <v-text-field :rules="textRules" type="number" :label="TranslateText('TCP OUT IP Port')"
                                v-model="form.Tcp_Out_Port"></v-text-field>
                            <v-text-field :rules="textRules" :label="TranslateText('Websocket IP Address')" v-model="form.Ws_Ip"></v-text-field>
                            <v-text-field :rules="textRules" type="number" :label="TranslateText('websocket port')"
                                v-model="form.Ws_Port"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-end>
                        <v-btn :disabled="!valid" type="submit" color="primary" @click.prevent="SaveSystemSettings">Save</v-btn>
                        <v-btn to='/account'>Cancel</v-btn>
                    </v-layout>
                </v-form>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import JWT from 'jsonwebtoken'

    export default {
        data() {
            return {
                form: {
                    ID: null,
                    AccountID: null,
                    Rng_Ip: null,
                    Rng_Port: null,
                    Clickatell_Key: null,
                    Sendgrid_Key: null,
                    Tcp_In_Ip: null,
                    Tcp_In_Port: null,
                    Tcp_Out_Ip: null,
                    Tcp_Out_Port: null,
                    Ws_Ip: null,
                    Ws_Port: null,
                },
                valid: true,
                showSaved: false,
                textRules: [
                    v => !!v || "Value is required",
                ],
            };
        },
        mounted() {
            var self = this;

            self.fetchData();
        },
        methods: {
            fetchData() {
                let self = this;
                let AccountID = JWT.decode(sessionStorage['accessToken']).ACCOUNT_ID;

                self.$refs.Loader.show();
                self.get('AccountSystemSettings/ByAccount?iAccount=' + AccountID)
                    .then(response => {
                        self.$refs.Loader.hide();
                        self.form.ID = response.data.ID;
                        self.form.AccountID = response.data.AccountID;
                        self.form.Rng_Ip = response.data.Rng_Ip;
                        self.form.Rng_Port = response.data.Rng_Port;
                        self.form.Clickatell_Key = response.data.Clickatell_Key;
                        self.form.Sendgrid_Key = response.data.Sendgrid_Key;
                        self.form.Tcp_In_Ip = response.data.Tcp_In_Ip;
                        self.form.Tcp_In_Port = response.data.Tcp_In_Port;
                        self.form.Tcp_Out_Ip = response.data.Tcp_Out_Ip;
                        self.form.Tcp_Out_Port = response.data.Tcp_Out_Port;
                        self.form.Ws_Ip = response.data.Ws_Ip;
                        self.form.Ws_Port = response.data.Ws_Port;
                    })
                    .catch(error => {
                        self.$refs.Loader.hide();
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to get system settings");
                    })
            },
            SaveSystemSettings() {
                var self = this;

                var Request = self.form;
                Request.AccountID = JWT.decode(sessionStorage['accessToken']).ACCOUNT_ID;

                console.log(Request)
                self.$refs.Loader.show();
                self.post("AccountSystemSettings", Request)
                    .then(res => {
                        self.$refs.Loader.hide();
                        self.$refs.SuccessModal.show(); // success modal
                        self.$refs.SuccessModal.setText("Updated system settings");

                        setTimeout(function () { // hide modal after 1 second
                            self.$refs.SuccessModal.hide();
                        }, 1000)
                    })
                    .catch(err => {
                        console.log(err);
                        self.$refs.Loader.hide();
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to update system settings");
                    });

            }
        }
    }
</script>